import { Link } from "react-router-dom";
import { BookOpen } from "lucide-react";
import { useModuleHelp } from "../../context/ModuleHelpContext";
import { getModuleHelpSection } from "../../config/moduleHelp";
import { docsHref } from "../../lib/docsCatalog";

export function ModuleIntroModal() {
  const { config, introOpen, dismissIntro, setPanelEnabled } = useModuleHelp();

  if (!introOpen) return null;

  const intro = getModuleHelpSection(config, config.introSectionId);
  const manualHref = docsHref(config.docId);

  return (
    <div
      className="fixed inset-0 z-50 flex items-center justify-center p-4 bg-brand-dark/25 backdrop-blur-[2px]"
      role="dialog"
      aria-modal="true"
      aria-labelledby="module-intro-title"
      onClick={() => dismissIntro()}
    >
      <div
        className="w-full max-w-md rounded-2xl border border-brand-soft bg-white shadow-xl p-6 space-y-4"
        onClick={(e) => e.stopPropagation()}
      >
        <div>
          <p className="text-[10px] font-bold uppercase tracking-widest text-brand-dark/45 mb-1">
            Primera visita
          </p>
          <h2 id="module-intro-title" className="text-lg font-extrabold text-brand-dark">
            {intro.title}
          </h2>
        </div>

        <ul className="space-y-2 text-sm text-brand-dark/75 leading-relaxed list-disc pl-4">
          {intro.bullets.map((line) => (
            <li key={line}>{line}</li>
          ))}
        </ul>

        <p className="text-xs text-brand-dark/55">
          Puede activar un panel de ayuda con el botón{" "}
          <span className="font-semibold text-brand-dark/70">Ayuda</span> en cualquier momento.
        </p>

        <div className="flex flex-wrap gap-2 pt-1">
          <button
            type="button"
            onClick={() => dismissIntro()}
            className="px-4 py-2 rounded-xl bg-brand-primary text-white text-sm font-bold"
          >
            Entendido
          </button>
          <button
            type="button"
            onClick={() => {
              setPanelEnabled(true);
              dismissIntro();
            }}
            className="px-4 py-2 rounded-xl border border-brand-primary text-brand-primary text-sm font-semibold"
          >
            Activar ayuda y continuar
          </button>
        </div>

        <Link
          to={manualHref}
          onClick={() => dismissIntro()}
          className="inline-flex items-center gap-1.5 text-xs font-semibold text-brand-primary hover:underline"
        >
          <BookOpen size={14} />
          Abrir manual completo
        </Link>
      </div>
    </div>
  );
}
